import type { PlanComparison } from "@/services/types"
import { cn } from "@/shared/lib/cn"

const EMPTY_CELL = "—"

export function PlanComparisonTable({ comparison }: { comparison: PlanComparison }) {
  const { headers, rows, featuredIndex } = comparison

  return (
    // A tabela tem ate cinco colunas e nao cabe num celular. `overflow-x-auto`
    // limita a rolagem horizontal a ela — sem isso, a pagina inteira rola de
    // lado no mobile.
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm border-collapse">
        <thead>
          <tr>
            <th
              scope="col"
              className="text-left py-3 pr-6 pl-0 text-xs font-semibold text-verde-profundo/35 uppercase tracking-widest w-[148px] whitespace-nowrap"
            >
              Critério
            </th>
            {headers.map((header, index) => (
              <th
                key={header}
                scope="col"
                className={cn(
                  "text-center py-3 px-3 text-xs font-bold tracking-wide min-w-[104px] whitespace-nowrap",
                  index === featuredIndex ? "text-verde-profundo bg-verde-profundo/5 rounded-t-lg" : "text-verde-profundo/50",
                )}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.label} className={rowIndex % 2 === 0 ? undefined : "bg-verde-profundo/[0.022]"}>
              <th
                scope="row"
                className="text-left py-2.5 pr-6 pl-0 text-xs font-medium text-verde-profundo/50 leading-snug border-t border-verde-profundo/6 whitespace-nowrap"
              >
                {row.label}
              </th>

              {row.values.map((value, columnIndex) => (
                <td
                  key={`${row.label}-${headers[columnIndex] ?? columnIndex}`}
                  className={cn(
                    "py-2.5 px-3 text-center text-[11px] leading-snug border-t border-verde-profundo/6",
                    columnIndex === featuredIndex
                      ? "font-semibold text-verde-profundo bg-verde-profundo/5"
                      : value === EMPTY_CELL
                        ? "text-verde-profundo/22"
                        : "text-verde-profundo/65",
                  )}
                >
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
